<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-文章-添加
    -->
  <div class="product-add pb50">
   <!--添加文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加任务</div>
      <el-form-item label="模板缩略图">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img :src="path" class="mt10" width="140px;" v-if="isImg" :isImg="isImg" />
          <p class="gray">*建议750X1334</p>
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="模板类型">
        <el-radio-group v-model="form.type">
          <el-radio :label="'10'">送朋友</el-radio>
          <el-radio :label="'20'">送父母</el-radio>
          <el-radio :label="'30'">送客户</el-radio>
          <el-radio :label="'40'">送小孩</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import CodeTemplateApi from '@/api/CodeTemplate.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      path: '',
      /*form表单数据*/
      form: {
        image_id: '',
        type: '10',
      },
      loading: false,
      /*验证规则*/
      rules: {
      }
    };
  },
  created() {

  },
  methods: {
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*添加任务*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CodeTemplateApi.addTemplate(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/codetemplate/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/codetemplate/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/codetemplate/codetemplate/add.vue